/* eslint-disable no-useless-constructor */
/* global DeferredMedia */

// Our boards are flat: open the 3D view looking straight at the top of the board,
// not from the low angle <model-viewer> starts at. The reader can still turn it.
window.lbFaceOn = (viewer) => {
  if (!viewer) return;
  // As attributes alone these are ignored once the viewer has loaded the model, so also
  // set them on the element and jump the camera there when the model is ready.
  const apply = () => {
    viewer.minCameraOrbit = 'auto 0deg auto';
    viewer.cameraOrbit = '0deg 0deg auto';
    if (viewer.jumpCameraToGoal) viewer.jumpCameraToGoal();
  };
  viewer.setAttribute('min-camera-orbit', 'auto 0deg auto');
  viewer.setAttribute('camera-orbit', '0deg 0deg auto');
  customElements.whenDefined('model-viewer').then(apply);
  viewer.addEventListener('load', apply, { once: true });
};

if (!customElements.get('product-model')) {
  class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    handleMouseMove(evt) {
      if (!this.modelViewer.classList.contains('shopify-model-viewer-ui__disabled')) {
        evt.preventDefault();
        evt.stopPropagation();
      }
    }

    loadContent() {
      super.loadContent();

      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this)
        }
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      this.modelViewer = this.querySelector('model-viewer');
      window.lbFaceOn(this.modelViewer);
      this.modelViewerUI = new Shopify.ModelViewerUI(this.modelViewer);
      this.addEventListener('mousemove', this.handleMouseMove.bind(this));
    }
  }

  customElements.define('product-model', ProductModel);
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this)
      }
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="product-json-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });

    window.ShopifyXR.setupXRElements();
  }
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
